import { Component, OnInit } from '@angular/core';

import {OrdemServicoStatus, ordensServicoModuleName, TipoOrdemServico} from "../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";
import {FuncionarioService} from "../../../recursos-humanos/funcionarios/funcionario.service";
import {FuncionarioApiService} from "../../../recursos-humanos/funcionarios/funcionario-api.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {MotoristaApiService} from "../../../recursos-humanos/motoristas/shared/motorista-api.service";
import {MotoristaService} from "../../../recursos-humanos/motoristas/shared/motorista.service";
import {frotasQuery} from "../../../bens/frotas/shared/data.service";
import {OrdemServico} from "../shared/ordem-servico.model";
import {manutencoesModuleName} from "../../shared/data.service";
import {LocalidadeApiService} from "../../../estruturas/localidades/shared/localidade-api.service";
import {localidadesQuery} from "../../../estruturas/localidades/shared/data.service";
import {OrdemServicoApiService} from "../shared/ordem-servico-api.service";
import {OrdemServicoService} from "../shared/ordem-servico.service";
import {OrdemServicoNavigationService} from "../shared/ordem-servico-navigation.service";

@Component({
    template: require('./ordem-servico-calendar.component.html'),
    styles: [require('./ordem-servico-calendar.component.css')]
})
export class OrdemServicoCalendarComponent implements OnInit {
    list: OrdemServico[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    ordemServicosModuleName: any = ordensServicoModuleName;
    module: any = manutencoesModuleName;

    statusSearch: any = {};
    statusList: any[] = [];
    tipoSearch: any = {};
    tiposList: any[] = [];
    localidadeSearch: any = {};
    localidadeSelectId: string = 'localidade';
    localidadeQuery: any = {};
    frotaSearch: any = {};
    frotaSelectId: string = 'frota';
    frotaQuery: any = {};
    
    constructor(
        private _ordemServicoApiService: OrdemServicoApiService,
        private _ordemServicoService: OrdemServicoService,
        private _ordemServicoNavigationService: OrdemServicoNavigationService,
        private _utilService: UtilService,

        private _localidadeApiService: LocalidadeApiService,
        private _frotaService: FrotasService,
        private _frotaApiService: FrotaApiService,
        private _autocompleteService: AutoCompleteService
    ) { }

    ngOnInit() {
        this.localidadeQuery = this._utilService.cloneObject(localidadesQuery);
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);

        this.getStatus();
        this.getTipos();
        this.clickClearSearch();

        this.createCalendar();
    }

    changeStatus() {
        this.queryMovimentacoes();
    }

    changeTipo() {
        this.queryMovimentacoes();
    }

    clickClearSearch() {
        this.statusSearch = this.statusList[0];
        this.statusSearch = this.statusList[0];

        this.frotaSearch = {};
        this.localidadeSearch = {};

        this._autocompleteService.setValueOnSelect2(null, "frota");
        this._autocompleteService.setValueOnSelect2(null, "localidade");

        this.queryMovimentacoes();
    }

    getLocalidadeObject(object: any) {
        this.localidadeSearch = object;
        this.queryMovimentacoes();
    }

    getFrotaObject(object: any) {
        this.frotaSearch = object;
        this.queryMovimentacoes();
    }

    frotaTemplateResult = (function(state: any) {
        let template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    private queryMovimentacoes() {
        let query: any = {"where":{}};

        if (this.statusSearch.Key) {
            query.where.status = this.statusSearch.Key;
        }

        if (this.tipoSearch.Key) {
            query.where.tipo = this.tipoSearch.Key;
        }

        if (this.localidadeSearch.id) {
            query.where.localidadeId = this.localidadeSearch.id;
        }

        if (this.frotaSearch.id) {
            query.where.bemId = this.frotaSearch.id;
        }

        query.where.ativo = true;

        this.getMovimentacoes(query);
    }

    private getMovimentacoes(query: any) {
        this.loading = true;
        this._ordemServicoApiService.onGetByFilter(query, this.onDone);
    }

    private onDone = (function(Response: any) {
        if (!Response.error)  {
            let x: number, lenX: number,
                eItem: any,
                events: any[] = [];

            for (x = 0, lenX = Response.length; x < lenX; x++) {
                Response[x].tipo = this._ordemServicoService.getTipoOrdemServico(Response[x].tipo);
                Response[x].status = this._ordemServicoService.getStatusOrdemServico(Response[x].status);

                eItem = this.calendarEvents(Response[x]);
                events.push(eItem);
            }

            this.list = events;
            this.setCalendarEvents(events);
        }
        this.loading = false;
    }.bind(this));

    private getStatus() {
        let list: any[] = this._utilService.cloneObject(OrdemServicoStatus);
        list.unshift({Key: null, Value: '— Status —'});
        this.statusList = list;
        this.statusSearch = this.statusList[0];
    }
    
    private getTipos() {
        let list: any[] = this._utilService.cloneObject(TipoOrdemServico);
        list.unshift({Key: null, Value: '— Tipo —'});
        this.tiposList = list;
        this.tipoSearch = this.tiposList[0];
    }

    private createCalendar() {
        let c: any = this._ordemServicoNavigationService;

        $('#calendar').fullCalendar({
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,basicWeek,basicDay'
            },
            locale: 'pt-br',
            height: 'auto',
            events: [],
            displayEventTime: false,
            eventRender: function(event, element) {
                var t: any = element.find('.fc-title');
                t.html(t.text());
            },
            eventClick: function(calEvent, jsEvent, view) {
                c.goToDetail(calEvent.id);
            }
        });

    }

    private setCalendarEvents(events: any) {
        $('#calendar').fullCalendar('removeEventSources');
        $('#calendar').fullCalendar('addEventSource', events);
    }

    private calendarEvents(item: any) {
        let tipo: string = '',
            localidade: string = '',
            bem: string = '',
            status: string = '',
            placa: string = '',
            title: any,
            cancelado: any = this._ordemServicoService.getStatusCancelado(),
            color: string = '#4C87FF';

        if (item.tipo) {
            tipo = item.tipo.Value;
        }
        if (item.status) {
            status = " - " + item.status.Value + "<br />";

            if (item.status.Key === cancelado.Key) {
                color = '#8e928e';
            }
        }
        if (item.localidade){
            localidade = "Localidade: " + item.localidade.localidade + "<br />";
        }

        if (item.bem){
            if (item.bem.placa) {
                placa = item.bem.placa.toUpperCase();
                placa = placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
                placa = " / ".concat(placa);
            }
            bem = " " + item.bem.identificacao + " " + placa + "<br />";
        }

        title = tipo + "" + status + "" + localidade + "" + bem;

        let event: any = {
            id: item.id,
            title: title,
            start: item.dataEntrada,
            end: item.dataSaida,
            color: color,
            textColor: '#FFFFFF'
        };

        return event;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordem-servico-calendar/ordem-servico-calendar.component.ts
 **/